/**
 * The search params the WBE owns. Shared so the header and the ad-format
 * switcher agree on spelling and ordering rather than each writing its own
 * literal into the URL.
 */
export const URL_PARAMS = {
  ARRIVAL: "arrival",
  DEPARTURE: "departure",
  ADULTS: "adults",
  TEENAGERS: "teenagers",
  CHILDREN: "children",
  INFANTS: "infants",
  LANG: "lang",
  /** Selected ad format. Absent means the site's own module. */
  MODULE: "module",
} as const;

/**
 * Fixed order for the params above; anything else is appended alphabetically.
 * `module` sits next to `lang` because both describe what is being shown
 * rather than what is being searched for.
 */
export const URL_PARAM_ORDER = [
  URL_PARAMS.LANG,
  URL_PARAMS.MODULE,
  URL_PARAMS.ARRIVAL,
  URL_PARAMS.DEPARTURE,
  URL_PARAMS.ADULTS,
  URL_PARAMS.TEENAGERS,
  URL_PARAMS.CHILDREN,
  URL_PARAMS.INFANTS,
] as const;

/**
 * The search string for a landing page reached by switching ad format: what
 * the guest entered, carried across, with the chosen format set.
 *
 * Everything else in the URL (category ids, previews, filters) describes the
 * page being left, so it is dropped — the same rule a logo click follows.
 */
export const getAdFormatNavigationSearch = (search: string, module: string): string => {
  const current = new URLSearchParams(search);
  const next = new URLSearchParams();

  URL_PARAM_ORDER.forEach((key) => {
    if (key === URL_PARAMS.MODULE) {
      next.set(key, module);
      return;
    }
    current.getAll(key).forEach((value) => next.append(key, value));
  });

  return next.toString();
};
